<template>
  <div></div>
</template>

<script>
export default {
  created() {
    this.unWatch = this.$watch(
      () => this.$store.getters["loginUser/status"],
      (state) => {
        if (state == "login") {
          this.$router
            .push(this.$route.query.returnUrl || "/home")
            .catch(() => {});
        } else if (state == "unlogin") {
          this.$router.push("/login").catch(() => {});
        }
      },
      {
        immediate: true,
      }
    );
  },
  destroyed() {
    this.unWatch();
  },
};
</script>

<style></style>
